import type { GetTweetById200AuthorBasicInfo } from './getTweetById200AuthorBasicInfo';
import type { GetTweetById200AuthorSocial } from './getTweetById200AuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type GetTweetById200Author = {
  /** 사용자 기본 정보 */
  basicInfo: GetTweetById200AuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetTweetById200AuthorSocial;
};
